import * as React from 'react'
import { Button } from '@mobiscroll/react-latest'
import { upperFirst } from 'lodash'
import { IBankAccountObj } from '../../../../types'
import UIMessages from 'src/utils/ui-messages'
import { handleRedirect } from 'src/utils'

interface IBankAccountListItemProps {
  bankAccount: IBankAccountObj
  onSetPrimaryBankAccount: (bankAccountId: string) => void
}

class BankAccountListItem extends React.Component<any, any> {
  constructor(props: IBankAccountListItemProps) {
    super(props)
  }

  public render() {
    const { account_holder_name, default_for_currency, id, last4, status } = this.props.bankAccount
    return (
      <div
        className={`${
          default_for_currency ? 'border-left-primary' : 'border-left-secondary'
        } bg-light-grey2 box-shadow flex flex-column justify-center p2 b-rad-6 w100`}
        style={{ minHeight: '165px' }}
      >
        {default_for_currency && <p className='font-grey2 mt0 bold'>{'Primary'}</p>}
        <p className='font-grey2 mb1'>{account_holder_name}</p>
        <span className='font-grey2'>{`**** **** **** ${last4}`}</span>
        {!default_for_currency && (
          <div className='flex items-center justify-end mt1'>
            <Button
              ariaLabel='Set as primary button'
              className='mbsc-success-btn'
              onClick={(e: React.MouseEvent) => this.setAccountAsPrimary(e)}
            >
              {UIMessages.organization.bankAccount.setPrimary}
            </Button>
            <Button
              ariaLabel='Delete button'
              className='mbsc-outline-danger-btn'
              onClick={(e: React.MouseEvent) => this.deleteAccount(e, id)}
            >
              {UIMessages.common.deleteLabel}
            </Button>
          </div>
        )}
      </div>
    )
  }

  private deleteAccount = (e: React.MouseEvent, id: string) => {
    e.preventDefault()
    handleRedirect(`${this.props.match.url}/bank-account/remove/${id}`)
  }

  private setAccountAsPrimary = (e: React.MouseEvent) => {
    e.preventDefault()
    this.props.onSetPrimaryBankAccount(this.props.bankAccount.id).then(() => window.location.reload())
  }
}

export default BankAccountListItem



// WEBPACK FOOTER //
// ./src/components/organizations/create/bankaccount/BankAccountListItem.tsx